
import Vue from "vue";
import Component from "vue-class-component";
import { TimelineMax } from "gsap";
import SectionLayout from "../SectionLayout.vue";
import BackgroundImage from "../BackgroundImage.vue";
import HomeHeaderVideoDialog from "./HomeHeaderVideoDialog.vue";
import PostChallengeDialog from "@/components/home/PostChallengeDialog/PostChallengeDialog.vue";
import { Prop } from "vue-property-decorator";

@Component({
  components: {
    SectionLayout,
    BackgroundImage,
    HomeHeaderVideoDialog,
    PostChallengeDialog
  }
})
export default class HomeHeader extends Vue {
  open: boolean = false;
  @Prop({ required: true, default: "" }) image!: string;

  solveChallenge() {
    this.$router.push("/challenges/in-progress");
  }
}
